import React, { FC, useState } from 'react';
import * as Styled from './MTabGroup.styles';
import { MTabGroupProps, MTabGroupAlignment } from './MTabGroup.types';
import { MTabItem } from '../MTabItem';
import { MControlTabScroll } from '../MControlTabScroll';
import { MControlTabScrollDirection } from '../MControlTabScroll/MControlTabScroll.types';

export const MTabGroup: FC<MTabGroupProps> = ({
  alignment = MTabGroupAlignment.Left,
  numberOfTabs = 3,
  icon = false,
  tabs = [],
  className = '',
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabClick = (index: number) => {
    setActiveTabIndex(index);
  };

  const handleScrollLeft = () => {
    if (activeTabIndex > 0) {
      setActiveTabIndex(activeTabIndex - 1);
    }
  };

  const handleScrollRight = () => {
    if (activeTabIndex < tabs.length - 1) {
      setActiveTabIndex(activeTabIndex + 1);
    }
  };

  const alignmentClass = alignment === MTabGroupAlignment.Centered ? 'centered' : 'left';

  return (
    <Styled.Wrapper className={`m-tab-group ${alignmentClass} ${className}`}>
      <Styled.TabContainer className="d-flex align-items-center">
        {tabs.length > numberOfTabs && (
          <MControlTabScroll
            direction={MControlTabScrollDirection.Left}
            onClick={handleScrollLeft}
            disabled={activeTabIndex === 0}
          />
        )}

        <Styled.TabsWrapper alignment={alignment} className="d-flex">
          {tabs.slice(0, numberOfTabs).map((tab, index) => (
            <MTabItem
              key={index}
              active={index === activeTabIndex}
              showIcon={icon}
              aIcon={tab.iconName ? { icon: tab.iconName } : undefined}
              label={tab.label}
              onTabClick={() => handleTabClick(index)}
            />
          ))}
        </Styled.TabsWrapper>

        {tabs.length > numberOfTabs && (
          <MControlTabScroll
            direction={MControlTabScrollDirection.Right}
            onClick={handleScrollRight}
            disabled={activeTabIndex === tabs.length - 1}
          />
        )}
      </Styled.TabContainer>
    </Styled.Wrapper>
  );
};
